import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { AuthService } from './business/auth.service';
import { catchError, tap } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

  constructor(
    private readonly _authService: AuthService,
    private readonly _router: Router,
  ) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // add authorization header with jwt token if available
    const token = this._authService.getToken();
    if (token) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });
    }

    return next.handle(request).pipe(
      catchError((error) => {
        const { status } = error;
        if (status === 401) {
          console.log(this._router.url);
          this._authService.removeToken(this._router.url.startsWith('/business/pwa') ? '/business/pwa/auth' : '/biznes');
          this._goToLoginPage();
        } else if (status === 403) {
          this._authService.removeToken(this._router.url.startsWith('/business/pwa') ? '/business/pwa/auth' : '/biznes');
        }
        this._saveJwtToken(error);
        return throwError(error);
      }),
      tap((response) => {
        if (response instanceof HttpResponse) {
          const tokenStr = response.headers.get('authorization');
          if (tokenStr !== null) {
            this._authService.setToken(tokenStr);
          }
        }
      })
    );
  }

  private _goToLoginPage(): void {
    const returnUrl = window.location.pathname;
    console.log(this._router.url);
    this._router.navigate([this._router.url.startsWith('/business/pwa') ? '/business/pwa/auth' : '/biznes'], { queryParams: { returnUrl } });
  }

  private _saveJwtToken(error) {
    const tokenStr = error.headers.get('authorization');
    if (tokenStr !== null) {
      this._authService.setToken(tokenStr.replace('Bearer ', ''));
    }
  }

}
